module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"zak.dog","short_name":"zak.dog","start_url":"/","background_color":"#0a0a0a","theme_color":"#0a0a0a","display":"minimal-ui","icon":"src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"5104222a1df6c61944105bcbc6cf23d2"},
    }]
